import { calibrationDeviceRailBranchVariants } from '@/features/calibration/config/calibrationDeviceRail';
import type {
  CalibrationDeviceTreeQuery,
  CalibrationDeviceTreeRow,
} from '@/features/calibration/types/calibrationDeviceTree';
import { ListNextPageFooter } from '@/shared/components/ListStatus';
import type { CSSProperties, Ref } from 'react';

export function CalibrationDeviceRailFooterRow({
  row,
  deviceQuery,
  measureRef,
  virtualIndex,
  style,
}: {
  row: Extract<CalibrationDeviceTreeRow, { kind: 'device-footer' }>;
  deviceQuery: CalibrationDeviceTreeQuery | undefined;
  measureRef: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  return (
    <li ref={measureRef} data-index={virtualIndex} style={style}>
      <div className={calibrationDeviceRailBranchVariants({ edge: row.edge })}>
        {deviceQuery ? <ListNextPageFooter query={deviceQuery} /> : null}
      </div>
    </li>
  );
}
